import styles from './Tab.module.css';
import { classNames } from '../../utils';
import { Props } from './TabTypes';
import { forwardRef } from 'react';

export const Tab = forwardRef<HTMLDivElement, Props>(({ label, icon, active, onClick, required, value }, ref) => {
    return (
        <div
            ref={ref}
            className={classNames(styles.container, active && styles.active)}
            onClick={() => onClick(value)}
        >
            {icon}
            <p>
                {label ? label : value}
                {required && <span className={styles.required}>*</span>}
            </p>
        </div>
    );
});

Tab.displayName = 'Tab';

export default Tab;
